import Vue from 'vue';
import VCalendar from 'v-calendar';

export default {
    init() {
        Vue.use(VCalendar);
    },
};
